import articleTags from './article-tags-data';

export class ArticleTagsService {
  constructor() {
    this.myArticlesTags = articleTags.filter((tagObj) => {
      return tagObj.isWrittenByMe;
    });

    this._setupRecommendationsTagsMap();
    this._setupMyArticlesTagsMap();
  }

  getRecommendationsTags() {
    return [...articleTags];
  }

  getRelevantRecommendationsTags(tags) {
    return tags.map((tag) => {
      return this.recommendationsTagsMap[tag];
    }).filter(x => x);
  }

  getMyArticleTags() {
    return this.myArticlesTags;
  }

  getRelevantMyArticleTags(tags) {
    return tags.map((tag) => {
      return this.myArticleTagsMap[tag];
    }).filter(x => x);
  }

  _setupMyArticlesTagsMap() {    
    this.myArticleTagsMap = {};
    this.getMyArticleTags().forEach((tagData) => {
      this.myArticleTagsMap[tagData.id] = tagData;
    });  
  }

  _setupRecommendationsTagsMap() {    
    this.recommendationsTagsMap = {};
    this.getRecommendationsTags().forEach((tagData) => {
      this.recommendationsTagsMap[tagData.id] = tagData;
    });  
  }  
}

const articleTagsService = new ArticleTagsService();

export default articleTagsService;